import React from 'react';
import './drawer.css';

const Drawer = ({ open, title, rows = [], onClose, wide = false, actions = null, children = null }) => {
  if (!open) return null;

  return (
    <>
      <div className="app-drawer-overlay" onClick={onClose} />
      <div className={`app-drawer ${wide ? 'app-drawer--wide' : ''}`}>
        <div className="app-drawer__header">
          <h4>{title}</h4>
          <div className="app-drawer__actions">
            {actions}
            <button className="app-drawer__close" onClick={onClose}>X</button>
          </div>
        </div>
        <div className={`app-drawer__body ${wide ? 'app-drawer__body--grid' : ''}`}>
          {rows.map((row, idx) => (
            <div key={`${row.label}-${idx}`} className="app-drawer__row">
              <span className="label">{row.label}</span>
              <span className="value">{row.value}</span>
            </div>
          ))}
          {children}
        </div>
      </div>
    </>
  );
};

export default Drawer;
